// Normalizes a TRIYO API payload into an array.
//
// The .NET API does not always return a bare array:
//   - /tasks/GetUserTaskListForAddin returns { Tasks: [...] }
//   - some endpoints return a bare array
//   - collections serialized with ReferenceHandler.Preserve are wrapped as
//     { $id: "1", $values: [...] }
export function toArray<T>(payload: unknown, ...keys: string[]): T[] {
  const unwrap = (value: unknown): T[] | null => {
    if (Array.isArray(value)) return value as T[];
    if (value && typeof value === "object" && Array.isArray((value as { $values?: unknown }).$values)) {
      return (value as { $values: T[] }).$values;
    }
    return null;
  };

  const direct = unwrap(payload);
  if (direct) return direct;

  if (payload && typeof payload === "object") {
    const obj = payload as Record<string, unknown>;
    for (const key of keys) {
      const nested = unwrap(obj[key]);
      if (nested) return nested;
    }
  }

  return [];
}
